import moment from "moment";

export default (query: any): string|null => {
  let prompt = '';
  const prompts = [];
  if (!query){
    return `geen zoekopdracht.`;
  }


  const readableDate = (date: string) => {
    let format = '';
    switch (date.length){
      case 4: format = 'YYYY'; break;
      case 7: format = 'MMMM YYYY'; break;
      default: format = 'LL'; break;
    }
    return moment(date).format(format);
  }
  if (query.first_name || query.last_name){
    const name = (query.first_name ?? '' + ' ' + query.last_name ?? '').trim();
    prompts.push(`naam: ${name}`)
  }
  if (query.birth_date){
    const prefix = query.birth_date.length === 10 ? 'op' : 'in'
    prompts.push(`geboren ${prefix}: ${readableDate(query.birth_date)}`)
  }
  if (query.placement_date){
    const prefix = query.placement_date.length === 10 ? 'op' : 'in'
    prompts.push(`plaatsing ${prefix}: ${readableDate(query.placement_date)}`)
  }
  // if (query.placement_date_from || query.placement_date_to){
  //   if (!query.placement_date_to){
  //     prompts.push(`plaatsing na: ${readableDate(query.placement_date_from)}`)
  //   } else if (!query.placement_date_from){
  //     prompts.push(`plaatsing voor: ${readableDate(query.placement_date_to)}`)
  //   } else {
  //     prompts.push(`plaatsing tussen ${readableDate(query.placement_date_from)} en ${readableDate(query.placement_date_to)}`)
  //   }
  // }
  if (query.deceased_date_from || query.deceased_date_to){
    if (!query.deceased_date_to){
      prompts.push(`overleden na: ${readableDate(query.deceased_date_from)}`)
    } else if (!query.deceased_date_from){
      prompts.push(`overleden voor: ${readableDate(query.deceased_date_to)}`)
    } else {
      prompts.push(`overleden tussen ${readableDate(query.deceased_date_from)} en ${readableDate(query.deceased_date_to)}`)
    }
  }

  // key value pair
  const readablePlaceType: {[key: string]: string} = {
    place: 'plaats',
    municipality: 'gemeente',
    province: 'provincie',
  };

  if (query.places?.length > 0){

    prompts.push('in ' + query.places.map((place: any) => {

      const prefix = readablePlaceType[place.type]
      return prefix + ' ' + place.label
    }).join(' of '))
  } else if (query.province){
    prompts.push(`provincie: ${query.province.title}`)
  }

  if (query.papers?.length > 0){
    prompts.push(`geplaatst in ${query.papers.length > 1 ? 'kranten' : 'krant'}: ${query.papers.map((paper: any) => paper.title).join(', ')}`)
  }
  if (prompts.length === 0){
    return null;
  }

  return prompt + prompts.join(', ') + '.'
}